import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from 'src/app/services/login.service';
import jwt_decode from "jwt-decode";
import { MessageService } from 'primeng/api';
import { PreCandidato } from 'src/app/models/preCandidato.model';

@Component({
  selector: 'app-pre-candidatura-realizada',
  templateUrl: './pre-candidatura-realizada.component.html',
  styleUrls: ['./pre-candidatura-realizada.component.css']
})
export class PreCandidaturaRealizadaComponent implements OnInit {


  showPage: boolean = false;
  instrucao:any;
  token: any;
  idEleicao: number;
  eleicaoRota: any;
  loginService: LoginService;
  informacoesToken: any;
  preCandidato: PreCandidato;
  cargo: string;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    protected auth: LoginService,
    protected messageService: MessageService,
  ) { }

  ngOnInit() {
    this.instrucao = " Para editar a candidatura, clique em 'voltar' abaixo. Para sair do sistema, feche a aba.";
    var formularioPreenchido = sessionStorage.getItem("formularioPreenchido") === "true";
    this.instrucao = (formularioPreenchido ? "Sua candidatura foi editada com sucesso e será analisada."
    : "Sua candidatura foi realizada com sucesso e será analisada.") + this.instrucao;
    this.preCandidato = JSON.parse(sessionStorage.getItem("preCandidato"));
    this.cargo = sessionStorage.getItem("cargo");
    this.spinner.hide();
  }

  public voltar() {
    this.spinner.show();
    this.router.navigate(['..'], {relativeTo: this.route})
  }

}
